import React from 'react';
import { FaBars, FaTimes } from 'react-icons/fa';
import { useSidebar } from '../../../context/AdminContext';
import ProfileDropdown from './ProfileDropdown';
import '../../../assets/css/admin/adminPageLayout/adminnavbar.css';

const AdminNavbar = () => {
  const { isSidebarOpen, toggleSidebar } = useSidebar();

  return (
    <nav className="jj-navbar">
      <div className="jj-navbar-content">
        <div className="jj-navbar-left">
          <button
            className="jj-navbar-toggle" onClick={toggleSidebar} aria-label="Toggle Sidebar" >{isSidebarOpen ? <FaTimes /> : <FaBars />}</button>
             <div className="jj-navbar-title">
            <h1 className="jj-navbar-heading">Dashboard</h1>
          </div>
        </div>
        <div className="jj-navbar-right">
         
          <ProfileDropdown />
        </div>
      </div>
    </nav>
  );
};

export default AdminNavbar;